/**
 * Vuex module for payment-related state.
 * Stores pending reservation data securely in memory instead of sessionStorage.
 */

const state = {
  pendingReservation: null
};

const mutations = {
  SET_PENDING_RESERVATION(state, reservationData) {
    state.pendingReservation = reservationData;
  },
  CLEAR_PENDING_RESERVATION(state) {
    state.pendingReservation = null;
  }
};

const actions = {
  setPendingReservation({ commit }, reservationData) {
    commit('SET_PENDING_RESERVATION', reservationData);
  },
  clearPendingReservation({ commit }) {
    commit('CLEAR_PENDING_RESERVATION');
  }
};

const getters = {
  pendingReservation: (state) => state.pendingReservation,
  hasPendingReservation: (state) => state.pendingReservation !== null
};

export const payment = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
